import * as ko from "knockout";
import {ParticipantDto, TripDto} from "./api/generated";
import {extend, observable, observableArray} from "knockout-decorators";

/**
 * A oeamtc user object returned by header/footer api
 */
export interface User {
    /**
     * Clubkartennummer.
     */
    pnr: string;
    email: string;
    title?: string;
    firstname: string;
    lastname: string;
    sessionId: string;
    isCompany: boolean;
    isEmployee: boolean;
    isMember: boolean;
    hasPayed: boolean;
    userId: number;
    identityKey: string;
}

/**
 * Global observables used trough out the application.
 */
export class GlobalState {
    /**
     * Triggers the loading indicator.
     */
    public loading: KnockoutObservable<boolean> = ko.observable(true);

    /**
     * The logged in user or null if not logged in.
     */
    public user: KnockoutObservable<User> = ko.observable(null);

    /**
     * Check whether the user is logged in.
     */
    public isLoggedIn = ko.pureComputed(() => this.user() != null);

    /**
     * The trips of the current/anonymous user.
     */
    public trips: KnockoutObservableArray<TripDto> = ko.observableArray([]);

    /**
     * The current trip.
     */
    @extend({deferred: true})
    @observable({deep: true, expose: true})
    public currentTrip: TripDto;

    /**
     * The current participants.
     */
    @observableArray({deep: true, expose: true})
    public currentParticipants: ParticipantDto[];

    /**
     * Triggers scrollToError.
     */
    public hasErrors: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Is the login overlay displayed.
     */
    public loginOverlayVisible: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Flag for trip picture selection.
     */
    public tripPicturesVisible: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Flag whether the app is embedded in the ReiseApp.
     */
    public isReiseApp = ko.observable(false);
    public reiseAppTrip = ko.observable('neu');
}

/**
 * Exports a singleton state object.
 */
export default new GlobalState();
